<div class="fx-row fx-wrap align-items-center justify-content-start  fx-flex-100">
    <div class="fx-row fx-wrap align-items-start justify-content-between fx-flex-100" *ngIf="organization">
        <div class="fx-column align-items-start justify-content-start">
            <span class="title bold">{{'ORGANIZATION.SUBSCRIPTION' | translate}}</span>
            <span class="text light">{{'ORGANIZATION.SUBSCRIPTION_HINT' | translate}}</span>
        </div>
        <!-- <div class="fx-row align-items-center justify-content-end">
            <button class="main-button ml-10" (click)="invite()" aclBasedElement resource="USER" [scopes]="['C']">
                <div class="fx-row align-items-center justify-content-center">
                    <mat-icon class="white mr-5" fontSet="material-icons-outlined">person_add</mat-icon>
                    {{'ORGANIZATION.INVITE_USER' | translate}}
                </div>
            </button>
        </div> -->
    </div>
    <mat-divider class="mv-16 fx-flex-100"></mat-divider>
    <div class="fx-row align-items-start justify-content-start fx-flex-100"
        *ngIf="organization && organization.subscription && organization.subscription.plan">
        <div class="fx-flex-50 pr-8">
            <mat-card class="p-0">
                <div class="p-16">
                    <span class="text bold main">{{'ORGANIZATION.SUBSCRIPTION' | translate}}</span>
                </div>
                <mat-divider></mat-divider>
                <div class="fx-flex-100 fx-row fx-wrap p-16">
                    <span class="text bold mb-8  fx-flex-100">{{'ORGANIZATION.BASE_PLAN' | translate}}</span>
                    <div class="fx-flex-100 fx-row justify-content-between align-items-center">
                        <span class="text light">{{'ORGANIZATION.PLAN' | translate}}</span>
                        <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                        <span class="text bold main">{{organization.subscription.plan.label}}</span>
                    </div>
                    <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                        *ngIf="organization.subscription.plan.maxVolume">
                        <span class="text light">{{'PLAN.MAX_VOLUME' | translate}}</span>
                        <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                        <span class="text dark">{{organization.subscription.plan.maxVolume}} Go</span>
                    </div>
                    <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                        *ngIf="organization.subscription.plan.maxTrademarks">
                        <span class="text light">{{'PLAN.MAX_TRADEMARKS' | translate}}</span>
                        <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                        <span class="text dark">{{organization.subscription.plan.maxTrademarks}}</span>
                    </div>
                    <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                        *ngIf="organization.subscription.plan.maxCases">
                        <span class="text light">{{'PLAN.MAX_CASES' | translate}}</span>
                        <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                        <span class="text dark">{{organization.subscription.plan.maxCases}}</span>
                    </div>
                    <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                        *ngIf="organization.subscription.plan.maxCrawlerUrl">
                        <span class="text light">{{'PLAN.MAX_CRAWLER_URL' | translate}}</span>
                        <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                        <span class="text dark">{{organization.subscription.plan.maxCrawlerUrl}}</span>
                    </div>
                    <span class="text bold mt-16 mb-8  fx-flex-100">{{'ORGANIZATION.OPTIONS' | translate}}</span>
                    <span class="text light fx-flex-100"
                        *ngIf="!organization.subscription.additionalVolume && !organization.subscription.additionalTrademarks && !organization.subscription.additionalCases && !organization.subscription.additionalCrawlerUrl">{{'ORGANIZATION.NO_OPTION'
                        | translate}}</span>
                    <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                        *ngIf="organization.subscription.additionalVolume">
                        <span class="text light">{{'ORGANIZATION.ADDITIONAL_VOLUME' | translate}}</span>
                        <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                        <span class="text dark">{{organization.subscription.additionalVolume}} Go</span>
                    </div>
                    <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                        *ngIf="organization.subscription.additionalTrademarks">
                        <span class="text light">{{'ORGANIZATION.ADDITIONAL_TRADEMARKS' | translate}}</span>
                        <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                        <span class="text dark">{{organization.subscription.additionalTrademarks}}</span>
                    </div>
                    <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                        *ngIf="organization.subscription.additionalCases">
                        <span class="text light">{{'ORGANIZATION.ADDITIONAL_CASES' | translate}}</span>
                        <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                        <span class="text dark">{{organization.subscription.additionalCases}}</span>
                    </div>
                    <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                        *ngIf="organization.subscription.additionalCrawlerUrl">
                        <span class="text light">{{'ORGANIZATION.ADDITIONAL_CRAWLER_URL' | translate}}</span>
                        <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                        <span class="text dark">{{organization.subscription.additionalCrawlerUrl}}</span>
                    </div>
                </div>
            </mat-card>
        </div>
        <div class="fx-flex-50 pl-8">
            <mat-card class="fx-flex-100 fx-row fx-wrap justify-content-start align-items-center m-0 mb-16"
                *ngIf="organization.subscription.plan.maxVolume">
                <div class="fx-row align-items-center justify-content-start fx-flex-100">
                    <span class="text dark bold ">{{'PLAN.MAX_VOLUME' | translate}}</span>
                    <mat-icon class="red ml-5" *ngIf="quotas.volume.exceeded">error_outline</mat-icon>
                </div>
                <div class="fx-flex-100 fx-row fx-wrap justify-content-between align-items-center">
                    <span class="text dark">{{round(quotas.volume.value,1)}}/{{(organization.subscription.plan.maxVolume
                        +
                        (organization.subscription.additionalVolume || 0))}} Go</span>
                    <span class="text dark " [class.red]='quotas.volume.exceeded'
                        [class.bold]="quotas.volume.exceeded">{{round(quotaPercentage('volume'))}}%</span>
                </div>
                <app-progress-bar [mode]="'determinate'" [value]="quotaPercentage('volume')" [loading]="true"
                    class="fx-flex-100 mb-8"></app-progress-bar>
                <span class="text red mt-8 fx-flex-100"
                    *ngIf="quotas.volume.exceeded">{{'ORGANIZATION.MAX_VOLUME_EXCEEDED' |
                    translate}}</span>
            </mat-card>
            <mat-card class="fx-flex-100 fx-row fx-wrap justify-content-start align-items-center  m-0 mb-16"
                *ngIf="organization.subscription.plan.maxTrademarks && quotas && quotas.trademarks">
                <div class="fx-row align-items-center justify-content-start fx-flex-100">
                    <span class="text dark bold ">{{'PLAN.MAX_TRADEMARKS' | translate}}</span>
                    <mat-icon class="red ml-5" *ngIf="quotas.trademarks.exceeded">error_outline</mat-icon>
                </div>

                <div class="fx-flex-100 fx-row fx-wrap justify-content-between align-items-center">
                    <span class="text dark">{{quotas.trademarks.value}}/{{(organization.subscription.plan.maxTrademarks
                        +
                        (organization.subscription.additionalTrademarks || 0))}}</span>
                    <span class="text dark " [class.red]='quotas.trademarks.exceeded'
                        [class.bold]="quotas.trademarks.exceeded">{{round(quotaPercentage('trademarks'))}}%</span>
                </div>
                <app-progress-bar [mode]="'determinate'" [value]="quotaPercentage('trademarks')" [loading]="true"
                    class="fx-flex-100 mb-8"></app-progress-bar>
                <span class="text red fx-flex-100"
                    *ngIf="quotas.trademarks.exceeded">{{'ORGANIZATION.MAX_TRADEMARKS_EXCEEDED'
                    |
                    translate}}</span>
            </mat-card>
            <mat-card class="fx-flex-100 fx-row fx-wrap justify-content-start align-items-center  m-0"
                *ngIf="organization.subscription.plan.maxCases">
                <div class="fx-row align-items-center justify-content-start fx-flex-100">
                    <span class="text dark bold ">{{'PLAN.MAX_CASES' | translate}}</span>
                    <mat-icon class="red ml-5" *ngIf="quotas.cases.exceeded">error_outline</mat-icon>
                </div>
                <div class="fx-flex-100 fx-row fx-wrap justify-content-between align-items-center">
                    <span class="text dark">{{quotas.cases.value}}/{{(organization.subscription.plan.maxCases +
                        (organization.subscription.additionalCases || 0))}}</span>
                    <span class="text dark " [class.red]='quotas.cases.exceeded'
                        [class.bold]="quotas.cases.exceeded">{{round(quotaPercentage('cases'))}}%</span>
                </div>
                <app-progress-bar [mode]="'determinate'" [value]="quotaPercentage('cases')" [loading]="true"
                    class="fx-flex-100 mb-8"></app-progress-bar>
                <span class="text red mt-8 fx-flex-100"
                    *ngIf="quotas.cases.exceeded">{{'ORGANIZATION.MAX_CASES_EXCEEDED' |
                    translate}}</span>
            </mat-card>
            <mat-card class="fx-flex-100 fx-row fx-wrap justify-content-start align-items-center  m-0"
                *ngIf="quotas.crawlerUrls.subscribed > 0">
                <div class="fx-row align-items-center justify-content-start fx-flex-100">
                    <span class="text dark bold ">{{'PLAN.MAX_CRAWLER_URL' | translate}}</span>
                    <mat-icon class="red ml-5" *ngIf="quotas.crawlerUrls.exceeded">error_outline</mat-icon>
                </div>
                <div class="fx-flex-100 fx-row fx-wrap justify-content-between align-items-center">
                    <span class="text dark">{{quotas.crawlerUrls.value}}/{{quotas.crawlerUrls.subscribed}}</span>
                    <span class="text dark " [class.red]='quotas.crawlerUrls.exceeded'
                        [class.bold]="quotas.crawlerUrls.exceeded">{{round(quotaPercentage('crawlerUrls'))}}%</span>
                </div>
                <app-progress-bar [mode]="'determinate'" [value]="quotaPercentage('crawlerUrls')" [loading]="true"
                    class="fx-flex-100 mb-8"></app-progress-bar>
                <span class="text red mt-8 fx-flex-100"
                    *ngIf="quotas.crawlerUrls.exceeded">{{'ORGANIZATION.MAX_CRAWLER_URLS_EXCEEDED' |
                    translate}}</span>
            </mat-card>
        </div>
    </div>
</div>